import { render, staticRenderFns } from "./RootWeather.vue?vue&type=template&id=5f6c7bc5&"
import script from "./RootWeather.vue?vue&type=script&lang=ts&"
export * from "./RootWeather.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports